<template>
  <div
    class="w-full tw matters-page bg-white print:overflow-hidden"
    style="position: absolute; left: 0px"
  >
    <div class="container tw color-unset lineheight-unset flex flex-col">
      <div class="flex h-full w-full">
        <template v-if="meLoaded">
          <div class="px-4 pb-4 w-full" v-if="permissions?.matters?.create">
            <MattersUpgradeNotice />
            <MattersTable :state="state" />
          </div>
          <div v-else class="mt-8 w-full text-lg text-center font-semibold text-gray-800">
            You do not have permission to view this page!
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import type { PropType } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import type { UiRouterState } from '@/services/RouteService/UiRouterState';
import MattersTable from './MattersTable.vue';
import MattersUpgradeNotice from './components/MattersUpgradeNotice.vue';

const props = defineProps({
  state: { type: Object as PropType<UiRouterState>, required: false },
});

const meStore = useMeStore();
const { permissions, features } = storeToRefs(meStore);
const meLoaded = ref(false);

onMounted(async () => {
  await meStore.getMe();

  // Feature-flagged route (sc-46278): /matters is the rewritten Matters list.
  // Accounts without fizzyLiftingDrink enabled are sent to the current
  // experience at matters-next instead.
  if (!features.value?.fizzyLiftingDrink) {
    props.state?.go('matters-next', props.state?.params);
    return;
  }

  meLoaded.value = true;
});
</script>
